module.exports = __webpack_public_path__ + "img/add.b3e42a71.svg";